import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SubmittedFormPreviewService {

    constructor(
        private http: HttpClient
    ) { }

    getWorkPlaceOrdersWithTask(taskId) {
        return this.http.get(environment.serverUrl + '/task/getTaskWithWorkOrders/' + taskId);
    }

    getSubmittedFormPreviewHtml(taskId) {
        return this.http.get(environment.serverUrl + '/task/preview/' + taskId);
    }

    reviewForm(task) {
        return this.http.put(environment.serverUrl + '/task/review', task);
    }

    deleteForm(task) {
        return this.http.put(environment.serverUrl + '/task/delete', task);
    }
    // downloadAuthentication(password) {
    //     return this.http.post(environment.serverUrl + '/user/verifyPassword', password);
    // }
    downloadMultipleCSV(Obj) {
        return this.http.post(environment.serverUrl + '/task/downloadMultiplePdf', Obj, { responseType: 'blob' });
    }

    downloadLHoistCSV(Obj) {
        return this.http.post(environment.serverUrl + '/lhoist/excel', Obj, { responseType: 'blob' });
    }

    downloadMultiplePdf(Obj) {
        return this.http.post(environment.serverUrl + '/task/downloadtaskpdfs', Obj, { responseType: 'blob' });
    }

    downloadTake5Pdf(Obj) {
        return this.http.post(environment.serverUrl + '/dyno/take5', Obj, { responseType: 'blob' });
    }

    downloadFioreExcel(Obj) {
        return this.http.post(environment.serverUrl + '/niss/excel/nissShiftReport', Obj, { responseType: 'blob' });
    }

    downloadAesaExcel(Obj) {
        return this.http.post(environment.serverUrl + '/aesa/excel', Obj, { responseType: 'blob' });
    }

    getReviewFormTemplate() {
        return this.http.get(environment.serverUrl + '/taskTemplate/reviewTemplate' )
    }
}



// WEBPACK FOOTER //
// ./src/app/submitted-form-preview/submitted-form-preview.service.ts